
const infoData = [
    { presc: '탕전', division: '급여 구분', date: '2023-04-14', org:'으라차차 한의원', doctor: '안가청', request: '코끼리원외탕정' },
]

const medicineData = [
    { no: 1, name:'녹용', country:'국내산', ea: '20g', price: '1,000' },
    { no: 2, name:'녹용', country:'국내산', ea: '20g', price: '1,000' },
    { no: 3, name:'녹용', country:'국내산', ea: '20g', price: '1,000' },
    { no: 4, name:'녹용', country:'국내산', ea: '20g', price: '1,000' },
    { no: 5, name:'녹용', country:'국내산', ea: '20g', price: '1,000' },
]

const patientData = [
    { no: 1, name:'홍길동', gender:'남', age: '30', date: '2023-04-14' },
    { no: 2, name:'홍길동', gender:'남', age: '30', date: '2023-04-14' },
    { no: 3, name:'홍길동', gender:'남', age: '30', date: '2023-04-14' },
    { no: 4, name:'홍길동', gender:'남', age: '30', date: '2023-04-14' },
    { no: 5, name:'홍길동', gender:'남', age: '30', date: '2023-04-14' },
]

const patientInfoData = [
    { date: '2023-04-14', division: '탕전', desc: '처방명', doctor: '안가청' },
    { date: '2023-04-14', division: '탕전', desc: '처방명', doctor: '안가청' },
    { date: '2023-04-14', division: '탕전', desc: '처방명', doctor: '안가청' },
    { date: '2023-04-14', division: '탕전', desc: '처방명', doctor: '안가청' },
    { date: '2023-04-14', division: '탕전', desc: '처방명', doctor: '안가청' },
]

const medicineSearchData = [
    { name: '봉밀', country: '한국', subName:'꿀', price: 750 },
    { name: '봉밀', country: '한국', subName:'꿀', price: 750 },
    { name: '봉밀', country: '한국', subName:'꿀', price: 750 },
    { name: '봉밀', country: '한국', subName:'꿀', price: 750 },
    { name: '봉밀', country: '한국', subName:'꿀', price: 750 }
]

const selfDictionaryData = [
    { name:'내 처방', subName: '나의 처방', user: '안가청' },
    { name:'내 처방', subName: '나의 처방', user: '안가청' },
    { name:'내 처방', subName: '나의 처방', user: '안가청' },
    { name:'내 처방', subName: '나의 처방', user: '안가청' },
    { name:'내 처방', subName: '나의 처방', user: '안가청' },
    { name:'내 처방', subName: '나의 처방', user: '안가청' },
]

const dictionaryData = [
    { name:'가감위령탕', subName: '가감탕', user: '동의보감' },
    { name:'가감위령탕', subName: '가감탕', user: '동의보감' },
    { name:'가감위령탕', subName: '가감탕', user: '동의보감' },
    { name:'가감위령탕', subName: '가감탕', user: '동의보감' },
    { name:'가감위령탕', subName: '가감탕', user: '동의보감' },
    { name:'가감위령탕', subName: '가감탕', user: '동의보감' },
]

const beforeReceiptData = [
    { name:'식욕억제', date: '2022-04-05', user: '홍길동' },
    { name:'식욕억제', date: '2022-04-05', user: '홍길동' },
    { name:'식욕억제', date: '2022-04-05', user: '홍길동' },
    { name:'식욕억제', date: '2022-04-05', user: '홍길동' },
    { name:'식욕억제', date: '2022-04-05', user: '홍길동' },
]

const searchData = [
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 },
    { name: '녹용(별전/일반부)', country: '뉴질랜드', price: 750 }
]

export { 
    infoData, 
    medicineData, 
    patientData, 
    patientInfoData, 
    medicineSearchData,
    selfDictionaryData,
    dictionaryData,
    beforeReceiptData,
    searchData 
}